import { useTranslation } from 'react-i18next';
import './contact.css';
import background_careers_left from '../../assets/contact/background_careers_left.png';
import background_careers_left_mobile from '../../assets/contact/background_careers_left_mobile.png';
import icon_contact_email from '../../assets/contact/icon_contact_email.svg';
import icon_contact_email_white from '../../assets/contact/icon_contact_email_white.svg';
import icon_contact_website from '../../assets/contact/icon_contact_website.svg';
import icon_contact_address_white from '../../assets/contact/icon_contact_website_white.svg';
import icon_contact_address from '../../assets/contact/icon_contact_address.svg';
import icon_common_send from '../../assets/common/icon_common_send.svg';
import icon_contact_user from '../../assets/contact/icon_contact_user.svg';
import icon_contact_phone from '../../assets/contact/icon_contact_phone.svg';
import icon_contact_phone_white from '../../assets/contact/icon_contact_phone_white.svg';
import emailjs from 'emailjs-com';
import { useState, useEffect } from 'react';
import { handleEmailClick, handleWebClick } from '../../utils/utils';
import SuccessModal from '../../components/SuccessModal/SuccessModal';
import useIsMobile from '../../hooks/useIsMobile';

const Contact = () => {
    const isMobile = useIsMobile()
    const { t } = useTranslation();
    const { REACT_APP_EMAILJS_SERVICE_ID,
        REACT_APP_EMAILJS_TEMPLATE_ID,
        REACT_APP_EMAILJS_USER_ID,
        REACT_APP_EMAILJS_TEMPLATE_ID_ADMIN,
        REACT_APP_EMAIL_ADMIN
    }: any = process.env;
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });
    const [formDataValid, setFormDataValid] = useState(false);

    const [formDataValidEmail, setFormDataValidEmail] = useState(false);

    const [formDataValidPhone, setFormDataValidPhone] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'name') {
            setFormDataValid(false)
        }
        if (name === 'phone') {
            setFormDataValidPhone(false)
        }
        if (name === 'email') {
            setFormDataValidEmail(false)

        }
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!formData.name) {
            setFormDataValid(true)
        }
        if (!formData.email) {
            setFormDataValidEmail(true)
        }
        if (!formData.phone) {
            setFormDataValidPhone(true)
        }
        if (formData.name && formData.email && formData.phone) {
            // Email sending disabled
            console.log('Email sending is disabled. Form data:', formData);
            setShowSuccessModal(true);
            setFormData({
                name: '',
                email: '',
                phone: '',
                message: '',
            });
            
            /* 
            emailjs.send(REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, {
                from_name: formData.name,
                to_name: formData.name,
                message: formData.message,
                to_email: formData.email,
                to_phone: formData.phone,
            }, REACT_APP_EMAILJS_USER_ID)
                .then(
                    () => {
                        emailjs.send(REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID_ADMIN, {
                            from_name: formData.name,
                            to_name: formData.name,
                            message: formData.message,
                            to_email: formData.email,
                            to_phone: formData.phone,
                        }, REACT_APP_EMAILJS_USER_ID)
                            .then(
                                () => {
                                    console.log('SUCCESS!');
                                    setShowSuccessModal(true);
                                    setFormData({
                                        name: '',
                                        email: '',
                                        phone: '',
                                        message: '',
                                    })
                                },
                                (error) => {
                                    console.log('FAILED...', error.text);
                                },
                            );
                        setShowSuccessModal(true);
                        setFormData({
                            name: '',
                            email: '',
                            phone: '',
                            message: '',
                        })
                    },
                    (error) => {
                        console.log('FAILED...', error.text);
                    },
                );
            */
        }
    };
    return (
        <div className='remove-padding-bottom-mobile' style={{ backgroundColor: '#F1F1F1', paddingBottom: '68px' }}>
            <div className='contact-container'>
                {/* Left section with image and company info */}
                <div className='custom-contact-left contact-left font-tomorrow'>
                    <img
                        className='background-careers-left-mobile w-100'
                        src={isMobile ? background_careers_left_mobile : background_careers_left}
                        alt='Office'
                    />
                    <div className='contact-right-mobile-tablet font-tomorrow'>
                        <h2 className='font-bauhaus'>{t('contact.company.name')}</h2>
                        <p>
                            {t('contact.company.intro')}
                            {/*  */}
                        </p>
                        <div className='contact-info'>
                            <div className='info-item'>
                                <span>
                                    <img className='m-r-12-px' src={isMobile ? icon_contact_email_white : icon_contact_email} alt='Email' width={20} height={15}  />
                                    Email
                                </span>
                                <span className='text-right'>{t('contact.company.email')}</span>
                            </div>
                            <div className='info-item'>
                                <span>
                                    <img className='m-r-12-px' src={isMobile ? icon_contact_phone_white : icon_contact_phone} alt='Phone' width={20} height={15} />
                                    {t('contact.hotline')}
                                </span>
                                <span className='text-right'>{t('contact.company.hotline')}</span>
                            </div>
                            <div className='info-item'>
                                <span>
                                    <img className='m-r-12-px' src={isMobile ? icon_contact_address_white : icon_contact_address} alt='Address' width={20} height={15} />
                                    {t('contact.address')}
                                </span>
                                <span className='text-right'>{t('contact.company.address')}</span>
                            </div>
                            <div className='info-item'>
                                <span>
                                    <img className='m-r-12-px' src={isMobile ? icon_contact_address_white : icon_contact_website} alt='Website' width={20} height={15} />
                                    {t('contact.website')}
                                </span>
                                <span className='text-right'>{t('contact.company.website')}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right section with contact form */}
                <div className='contact-right font-tomorrow'>

                    <h2 className='font-bauhaus'>{t('contact.title')}</h2>
                    <p className='contact-subtitle'>{t('contact.subtitle')}</p>

                    <form onSubmit={handleSubmit} className='contact-form m-t-48-px'>
                        <div className='form-group'>
                            <label>{t('contact.name')} <span style={{ color: 'red' }}>*</span></label>
                            <div className='relative'>
                                <img
                                    style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)' }}
                                    src={icon_contact_user} alt='Email' />
                                <input
                                    style={{ paddingLeft: '42px', width: '100%' }}
                                    type='text'
                                    placeholder={t('contact.name.placeholder')}
                                    name='name'
                                    value={formData.name.substring(0, 100)}
                                    onChange={handleChange}
                                />
                            </div>
                            {formDataValid && <span style={{ color: 'red' }}>Trường không được bỏ trống</span>}
                        </div>
                        <div className='form-group'>
                            <label>{t('contact.email')} <span style={{ color: 'red' }}>*</span></label>
                            <div className='relative'>
                                <img
                                    style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)' }}
                                    src={icon_contact_email} alt='Email' />
                                <input
                                    style={{ paddingLeft: '42px', width: '100%' }}
                                    type='email'
                                    placeholder={t('contact.email.placeholder')}
                                    name='email'
                                    value={formData.email.substring(0, 255)}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            {formDataValidEmail && <span style={{ color: 'red' }}>Trường không được bỏ trống</span>}
                        </div>
                        <div className='form-group'>
                            <label>{t('contact.phone')} <span style={{ color: 'red' }}>*</span></label>
                            <div className='relative'>
                                <img
                                    style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)' }}
                                    src={icon_contact_phone} alt='Phone' />
                                <input
                                    className='w-100'
                                    style={{ paddingLeft: '42px', width: '100%' }}
                                    type='number'
                                    placeholder={t('contact.phone.placeholder')}
                                    name='phone'
                                    value={formData.phone.substring(0, 10)}
                                    onChange={handleChange}
                                />
                            </div>
                            {formDataValidPhone && <span style={{ color: 'red' }}>Trường không được bỏ trống</span>}
                        </div>
                        <div className='form-group'>
                            <label>{t('contact.message')}</label>
                            <textarea
                                className='w-100'
                                style={{ resize: 'none' }}
                                placeholder={t('contact.message.placeholder')}
                                name='message'
                                value={formData.message}
                                onChange={handleChange}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                            <button
                                type='submit'
                                className='submit-button d-flex justify-content-center align-items-center'
                            >
                                <img src={icon_common_send} alt='Send' width={20} height={20} style={{ marginRight: '6px' }} /> {t('contact.submit')}
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    // Handle schedule meeting
                                }}
                                className='submit-button submit-button-secondary d-flex justify-content-center align-items-center'
                            >
                                {t('contact.submit2')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <SuccessModal
                isOpen={showSuccessModal}
                message='Chúng tôi đã nhận được yêu cầu của bạn. Vui lòng kiểm tra email trong một vài ngày tới.'
                countdown={5}
                onClose={() => {
                    setShowSuccessModal(false);
                    // window.location.href = '/';
                }}
            />
        </div>
    );
};

export default Contact;